<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { onMount } from "svelte";
import Modal from "../modal.svelte";
export let open = false;
export let url = null;
export let onClose = () => {};
export let title = null;
export let iframeTitle = "Embedded content";
export let width = "850px";
export let maxWidth = "100vw";
export let maxHeight = "94vh";
export let maxHeightContent = "none";
export let padding = "1rem";
export let zIndexOverlay = 12e3;
export let zIndexUnderlay = 11999;
export let allow = "payment *; clipboard-write; geolocation; microphone; camera; autoplay; fullscreen; accelerometer; gyroscope; encrypted-media; midi; usb; xr-spatial-tracking";
// Payment iframes often navigate the top window on "Finish". We use both:
// - allow-top-navigation-by-user-activation: stricter, works on desktop when the gesture counts.
// - allow-top-navigation: needed on many mobile WebViews / when DevTools emulated taps do not
//   propagate user activation into a cross-origin iframe (Finish appears to do nothing).
// This component is only used for CubePay today; keep tokens minimal elsewhere if reusing.
export let sandbox = "allow-same-origin allow-forms allow-scripts allow-popups allow-modals allow-pointer-lock allow-downloads allow-top-navigation-by-user-activation allow-top-navigation";
export let referrerPolicy = "no-referrer-when-downgrade";
export let onMessage = undefined;
let iframeLoading = false;
$: iframeLoading = !!url && open;
$: useMarginTop = $stateUi.iframeModal?.useMarginTop ?? false;
onMount(() => {
	const handleMessage = (event) => {
		if (!open || !onMessage) return;
		onMessage(event);
	};
	window.addEventListener("message", handleMessage);
	return () => {
		window.removeEventListener("message", handleMessage);
	};
});
</script>

{#if open}
	<Modal
		scrollDisabled={false}
		closeModal={onClose}
		{width}
		{maxWidth}
		{maxHeight}
		{maxHeightContent}
		{padding}
		{zIndexOverlay}
		{zIndexUnderlay}
		{title}
		showCloseButton={true}
		customStyleContent="overflow-y: hidden; padding: 0;"
	>
		<div
			class="iframe-container"
			style={`--iframe-max-height: ${maxHeight}; ${useMarginTop ? 'margin-top: 2rem;' : ''}`}
		>
			{#if url}
				{#if iframeLoading}
					<div class="iframe-loading">{$t(Verbiage.loading)}...</div>
				{/if}
				<iframe
					class="iframe-frame"
					src={url}
					title={iframeTitle}
					{allow}
					allowfullscreen
					{sandbox}
					referrerpolicy={referrerPolicy}
					on:load={() => (iframeLoading = false)}
				/>
				<div class="iframe-fallback">
					<a href={url} target="_blank" rel="noopener noreferrer">
						{$t(Verbiage.open_in_new_tab)}
					</a>
				</div>
			{:else}
				<div class="iframe-error">
					{$t(Verbiage.something_went_wrong)}
				</div>
			{/if}
		</div>
	</Modal>
{/if}

<style>
	.iframe-container {
		width: 100%;
		padding-bottom: 1rem
}

	.iframe-frame {
		display: block;
		width: 100%;
		border-radius: 0.75rem;
		height: min(calc(var(--iframe-max-height) - 8rem), 800px);
		border: 0
}

	.iframe-loading {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: center;
		padding-top: 1rem;
		padding-bottom: 1rem;
		text-align: center;
		opacity: 0.8
}

	.iframe-fallback {
		margin-top: 0.75rem;
		text-align: center
}

	.iframe-error {
		width: 100%;
		padding-top: 2rem;
		padding-bottom: 2rem;
		text-align: center;
		opacity: 0.8
}
</style>
